var map = {
	"./AAVE.svg": 479,
	"./AAVEe.svg": 480,
	"./ADA.svg": 481,
	"./ADX.svg": 482,
	"./ALPACA.png": 483,
	"./ALPHA.png": 484,
	"./ANN.png": 485,
	"./ANY.png": 486,
	"./ARBITRUM.svg": 487,
	"./ATOM.png": 488,
	"./AURO.png": 489,
	"./AVALANCHE.svg": 490,
	"./AVAX.png": 491,
	"./AXS.png": 492,
	"./BABYCAKE.svg": 493,
	"./BAKE.png": 494,
	"./BALL.png": 495,
	"./BANANA.svg": 496,
	"./BCH.svg": 497,
	"./BDO.png": 498,
	"./BDP.png": 499,
	"./BEAR.png": 500,
	"./BETH.png": 501,
	"./BHC.png": 502,
	"./BIFI.png": 503,
	"./BMON.svg": 504,
	"./BNB.png": 505,
	"./BONE.png": 506,
	"./BONEswap.png": 507,
	"./BOO.png": 508,
	"./BORING.png": 509,
	"./BP.png": 510,
	"./BSC.svg": 511,
	"./BSCDEFI.svg": 512,
	"./BSCPAD.png": 513,
	"./BTC.svg": 514,
	"./BTCB.svg": 515,
	"./BTD.png": 516,
	"./BTS.png": 517,
	"./BTT.png": 518,
	"./BUNNY.png": 519,
	"./BURGER.png": 520,
	"./BUSD.svg": 521,
	"./BUSDe.svg": 522,
	"./CAKE.svg": 523,
	"./CAPS.svg": 524,
	"./CARROT.png": 525,
	"./CHESS.svg": 526,
	"./CRV.png": 527,
	"./CTK.png": 528,
	"./CYT.png": 529,
	"./CZF.png": 530,
	"./DAI.png": 531,
	"./DAI.svg": 532,
	"./DAIe.png": 533,
	"./DELIRIUM.png": 534,
	"./DFYN.png": 535,
	"./DG.png": 536,
	"./DINO.png": 537,
	"./DIS.svg": 538,
	"./DOT.png": 539,
	"./DRUGS.png": 540,
	"./DVI.svg": 541,
	"./ELK.png": 542,
	"./EPS.png": 543,
	"./ETH.svg": 544,
	"./EZ.png": 545,
	"./FANTOM.svg": 546,
	"./FET.png": 547,
	"./FFF.png": 548,
	"./FIL.svg": 549,
	"./FISH.svg": 550,
	"./FOO.png": 551,
	"./FORM.svg": 552,
	"./FRAX.png": 553,
	"./FRUIT.png": 554,
	"./FTM.png": 555,
	"./GHST.png": 556,
	"./GNT.png": 557,
	"./GUARD.svg": 558,
	"./HAI.png": 559,
	"./HARD.png": 560,
	"./HARMONY.svg": 561,
	"./HBTC.png": 562,
	"./HECO.svg": 563,
	"./HERO.png": 564,
	"./HONEY.png": 565,
	"./HONOR.png": 566,
	"./HOTCROSS.svg": 567,
	"./HPS.png": 568,
	"./HT.png": 569,
	"./HTB.svg": 570,
	"./HUSD.png": 571,
	"./ICA.svg": 572,
	"./ICE.png": 573,
	"./IF.svg": 574,
	"./INCH.png": 575,
	"./INJ.png": 576,
	"./IRON.png": 577,
	"./JETS.png": 578,
	"./JOE.png": 579,
	"./JULD.png": 580,
	"./KEBAB.png": 581,
	"./KRW.png": 582,
	"./LAND.svg": 583,
	"./LINK.png": 584,
	"./LINKe.png": 585,
	"./LITHIUM.svg": 586,
	"./LONG.png": 587,
	"./LTC.svg": 588,
	"./LUNA.png": 589,
	"./MAI.png": 590,
	"./MARSH.png": 591,
	"./MASK.svg": 592,
	"./MATIC.svg": 593,
	"./MCRN.svg": 594,
	"./MDX.png": 595,
	"./MERL.svg": 596,
	"./METAHERO.svg": 597,
	"./MIM.png": 598,
	"./MOON.png": 599,
	"./MORRALLA.png": 600,
	"./MORRALLA.svg": 601,
	"./MSC.png": 602,
	"./MSS.png": 603,
	"./MUST.png": 604,
	"./NAOS.png": 605,
	"./NEXO.png": 606,
	"./NFT.png": 607,
	"./NUTS.png": 608,
	"./NYA.png": 609,
	"./NYAC.png": 610,
	"./NYAS.png": 611,
	"./O3.png": 612,
	"./OCP.png": 613,
	"./ONE.svg": 614,
	"./ONG.svg": 615,
	"./ONT.png": 616,
	"./OOE.svg": 617,
	"./ORBS.svg": 618,
	"./PACOCA.svg": 619,
	"./PAUTO.png": 620,
	"./PBNB.png": 621,
	"./PEAR.svg": 622,
	"./PERA.png": 623,
	"./PHA.png": 624,
	"./PMP.svg": 625,
	"./PNG.svg": 626,
	"./POLYGON.svg": 627,
	"./POTS.png": 628,
	"./PUP.png": 629,
	"./PolyDoge.png": 630,
	"./QBT.svg": 631,
	"./QI.png": 632,
	"./QUICK.png": 633,
	"./RABBIT.svg": 634,
	"./RAMP.png": 635,
	"./REVV.svg": 636,
	"./ROUTE.png": 637,
	"./SBDO.png": 638,
	"./SCREAM.png": 639,
	"./SFP.png": 640,
	"./SFUND.png": 641,
	"./SHADE.png": 642,
	"./SHIBX.png": 643,
	"./SISTA.svg": 644,
	"./SKILL.svg": 645,
	"./SMART.png": 646,
	"./SNX.png": 647,
	"./SOAK.png": 648,
	"./SOL.png": 649,
	"./SPADE.png": 650,
	"./SPELL.png": 651,
	"./SPIRIT.png": 652,
	"./SPS.svg": 653,
	"./STARS.svg": 654,
	"./START.png": 655,
	"./STEAK.png": 656,
	"./STEEL.png": 657,
	"./SUSHI.png": 658,
	"./SUSHIe.png": 659,
	"./SWAMP.svg": 660,
	"./SX.png": 661,
	"./SXP.svg": 662,
	"./SYN.svg": 663,
	"./TAPE.svg": 664,
	"./TEL.png": 665,
	"./TENFI.png": 666,
	"./TETU.svg": 667,
	"./TIME.png": 668,
	"./TITAN.svg": 669,
	"./TLOS.svg": 670,
	"./TREEB.png": 671,
	"./TRX.png": 672,
	"./TYPH.png": 673,
	"./UFT.png": 674,
	"./UNI.png": 675,
	"./UNIe.png": 676,
	"./USDC.svg": 677,
	"./USDCe.svg": 678,
	"./USDO.png": 679,
	"./USDT.svg": 680,
	"./USDTe.svg": 681,
	"./UST.png": 682,
	"./WATCH.png": 683,
	"./WAULTx.svg": 684,
	"./WBNB.svg": 685,
	"./WBTC.svg": 686,
	"./WBTCe.svg": 687,
	"./WETHe.svg": 688,
	"./WEX.svg": 689,
	"./WEXpoly.png": 690,
	"./WIN.png": 691,
	"./WMATIC.svg": 692,
	"./WMATIC_DFYN.svg": 693,
	"./WOO.svg": 694,
	"./WOOFY.png": 695,
	"./WSG.svg": 696,
	"./WUSD.svg": 697,
	"./XAVA.png": 698,
	"./XRP.svg": 699,
	"./XTZ.png": 700,
	"./XVS.png": 701,
	"./YAMP.svg": 702,
	"./YEL.svg": 703,
	"./YELD.png": 704,
	"./YFI.png": 705,
	"./YFIe.png": 706,
	"./YGG.png": 707,
	"./ZBTC.svg": 708,
	"./ZETH.svg": 709,
	"./ZOO.png": 710,
	"./aQI.png": 711,
	"./anyMTLX.png": 712,
	"./bscBUSD.svg": 713,
	"./cakeHARD.png": 714,
	"./cakeROOBEE.png": 715,
	"./cakeSTAX.png": 716,
	"./cakeTWT.png": 717,
	"./cakebROOBEE.png": 718,
	"./fUSD.png": 719,
	"./fUSDT.png": 720,
	"./fWINGS.svg": 721,
	"./ibBTC.svg": 722,
	"./pOPEN.webp": 723,
	"./pWINGS.png": 724,
	"./polyBUNNY.png": 725,
	"./polyWISE.png": 726,
	"./rUSD.svg": 727,
	"./renBTC.png": 728,
	"./renBTC.svg": 729,
	"./renDGB.svg": 730,
	"./renDOGE.png": 731,
	"./sALPACA.svg": 732,
	"./xMARK.png": 733,
	"./xYELD.svg": 734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1264;